<template>
    <div class="">
        <v-select
            v-model="equipment"
            ref="equipSelect"
            label="equipment_id"
            :filterable="false"
            :resetOnOptionsChange="resetOnOptionsChange"
            @search="onSearch"
            @input="onChange"
            :options="options"
            :value="selectedValues"
            :placeholder="`Search ${placeholder}`"
            :class="{'filter-select': forFilters, 'is-invalid': hasError}"
            :size="size">
            <template slot="no-options">
                Search for Equipment by Type, Model#, Serial#, or Name
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.equipment_type_name }} - {{ option.model_number }} - {{ option.serial_number }}
                    <template v-if="option.equipment_name">
                        - {{ option.equipment_name }}
                    </template>
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.equipment_type_name }} - {{ option.model_number }} - {{ option.serial_number }}
                    <template v-if="option.equipment_name">
                        - {{ option.equipment_name }}
                    </template>
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        props: {
            selectedValues: {
                type: Object,
                default: null
            },

            forFilters: {
                type: Boolean,
                default: false,
            },

            // excludeId: {
            //     type: Number,
            // },

            placeholder: {
                type: String,
                default: 'Equipment',
            },

            hasError: {
                type: Boolean,
                default: false,
            },

            resetOnOptionsChange: {
                type: Boolean,
                default: false,
            },

            size: {
                type: String,
                default: '',
            },

            filters: {
                type: Object,
                default: null
            },
        },

        data: function() {
            return {
                options: [],
                equipment: null,
            }
        },

        watch: {
            //Watcher for errors
            hasError(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            },

            selectedValues(newValue, oldValue){
                if(newValue != null && Object.keys(newValue).length > 0 && !this.equipment)
                {
                    this.options.push(newValue);
                    this.equipment = newValue;
                }
            }
        },

        methods: {
            //Search
            onSearch: function(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/equipment/search', {term: searchTerm, filters: this.filters})
                    .then(res => {
                        //Set the data
                        this.options = res.data;

                        //Done loading
                        searchLoading(false);
                    });
            },

            onChange: function (selected) {
                this.$emit('vuselected', this.equipment);
            },

            reset(){
                //Set to null
                this.equipment = null;
                this.selectedValues = null;
                this.options = [];
            },

            clearInput(){
                //Set to null
                this.employee = null;
                this.options = [];
                this.$refs.equipSelect.clearSelection();
            }
        },

        mounted() {
            //Push the selected value. Null will default to the placeholder
            if(this.selectedValues != null && Object.keys(this.selectedValues).length > 0)
            {
                this.options.push(this.selectedValues);
                this.equipment = this.selectedValues;
            }
        }
    }
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }
</style>